import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import LeadForm from "@/components/site/LeadForm";

export default function DemoModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-parchment border-ink rounded-none max-w-xl max-h-[90vh] overflow-y-auto"
        data-testid="demo-modal"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-ink font-normal">
            Book a technical demonstration
          </DialogTitle>
          <DialogDescription className="font-body text-umber">
            Tell us about your deployment constraints and the SureLoom team will
            arrange an architecture briefing.
          </DialogDescription>
        </DialogHeader>
        <LeadForm idPrefix="modal-lead" onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
